<template>
    <v-avatar left class="uku-group-avatar" :size="size" :class="className">
        <span :class="[text_class, 'font-weight-medium white--text']">
            {{ initials }}
        </span>
    </v-avatar>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
    name: "GroupAvatar",
    props: {
        size: {
            type: [String, Number],
            default: 40
        },
        initials: {
            type: String,
            default: ""
        },
        className: {
            type: String,
            default: ""
        }
    },
    setup(props) {
        const text_class = computed(function() {
            if (props.size <= 24) return "caption";
            if (props.size <= 32) return "body-2";
            return "subtitle-1";
        });

        return {
            text_class
        };
    }
}
</script>
